import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import Button from '@cdo/apps/legacySharedComponents/Button';
import MultipleSectionsAssigner from '@cdo/apps/templates/MultipleSectionsAssigner';
import {sectionForDropdownShape} from '@cdo/apps/templates/teacherDashboard/shapes';
import {
  assignToSection,
  unassignSection,
} from '@cdo/apps/templates/teacherDashboard/teacherSectionsRedux';
import {sectionsForDropdown} from '@cdo/apps/templates/teacherDashboard/teacherSectionsReduxSelectors';
import {AiChatToolsDependency} from '@cdo/generated-scripts/sharedConstants';
import i18n from '@cdo/locale';

class MultipleAssignButton extends React.Component {
  static propTypes = {
    courseId: PropTypes.number,
    courseOfferingId: PropTypes.number,
    courseVersionId: PropTypes.number,
    scriptId: PropTypes.number,
    assignmentName: PropTypes.string,
    reassignConfirm: PropTypes.func,
    isAssigningCourseOnly: PropTypes.bool,
    isSingleUnitCourse: PropTypes.bool,
    participantAudience: PropTypes.string,
    aiChatToolsDependency: PropTypes.oneOf(Object.values(AiChatToolsDependency))
      .isRequired,
    // Redux
    assignToSection: PropTypes.func.isRequired,
    isRtl: PropTypes.bool,
    sectionsForDropdown: PropTypes.arrayOf(sectionForDropdownShape).isRequired,
  };

  state = {
    assignmentChoiceDialogOpen: false,
  };

  onCloseDialog = () => {
    this.setState({
      assignmentChoiceDialogOpen: false,
    });
  };

  handleClick = () => {
    this.setState({
      assignmentChoiceDialogOpen: true,
    });
  };

  render() {
    const {assignmentChoiceDialogOpen} = this.state;
    const {
      courseId,
      courseOfferingId,
      courseVersionId,
      scriptId,
      assignmentName,
      isSingleUnitCourse,
      sectionsForDropdown,
      participantAudience,
      isAssigningCourseOnly,
      reassignConfirm,
      aiChatToolsDependency,
    } = this.props;

    return (
      <div>
        <Button
          color={Button.ButtonColor.brandSecondaryDefault}
          text={i18n.assignToMultipleSections()}
          icon="plus"
          onClick={this.handleClick}
          id="uitest-multi-assign-button"
        />
        {assignmentChoiceDialogOpen && (
          <MultipleSectionsAssigner
            assignmentName={assignmentName}
            onClose={this.onCloseDialog}
            sections={sectionsForDropdown}
            courseId={courseId}
            courseOfferingId={courseOfferingId}
            scriptId={scriptId}
            courseVersionId={courseVersionId}
            reassignConfirm={reassignConfirm}
            isAssigningCourseOnly={isAssigningCourseOnly}
            isSingleUnitCourse={isSingleUnitCourse}
            participantAudience={participantAudience}
            aiChatToolsDependency={aiChatToolsDependency}
          />
        )}
      </div>
    );
  }
}

export const UnconnectedMultipleAssignButton = MultipleAssignButton;

export default connect(
  (state, ownProps) => ({
    isRtl: state.isRtl,
    sectionsForDropdown: sectionsForDropdown(
      state.teacherSections,
      ownProps.courseOfferingId,
      ownProps.courseVersionId,
      state.progress.scriptId
    ),
  }),
  {
    assignToSection,
    unassignSection,
  }
)(MultipleAssignButton);
